import image1 from "../assets/img/als/clientes/image1.svg";
import image2 from "../assets/img/als/clientes/image2.svg";
import image3 from "../assets/img/als/clientes/image3.svg";
import image4 from "../assets/img/als/clientes/image4.svg";
import image5 from "../assets/img/als/clientes/image5.svg";
import image6 from "../assets/img/als/clientes/image6.svg";
import image8 from "../assets/img/als/clientes/image8.svg";
import image9 from "../assets/img/als/clientes/image9.svg";
import image10 from "../assets/img/als/clientes/image10.svg";
import image11 from "../assets/img/als/clientes/image11.svg";
import image12 from "../assets/img/als/clientes/image12.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"
// import colorSharp from "../assets/img/sharp-color.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="pilares">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>A ALS ENGENHARIA</h2>
                        <p>Somos uma empresa que surgiu de dentro do SENAI e hoje estamos alocando no HUB de Inovação da UNIFOR. Nosso objetivo é impulsionar a produtividade das indústrias locais através de inovações tecnológicas. Desenvolvemos projetos personalizados para reduzir desperdícios com o uso de automação e digitalização, adaptados às necessidades de cada empresa. Em parceria com o SENAI e a UNIFOR, oferecemos soluções inovadoras e sob medida para enfrentar os desafios únicos de cada negócio. Acreditamos que a automação e a digitalização são fundamentais para otimizar processos e aumentar a competitividade. Estamos comprometidos em ajudar as indústrias locais a adotar essas tecnologias e alcançar novos patamares de eficiência e sucesso.</p>
                        <p>Em parceria com o SENAI e a UNIFOR, oferecemos soluções inovadoras e sob medida para enfrentar os desafios únicos de cada negócio. Acreditamos que a automação e a digitalização são fundamentais para otimizar processos e aumentar a competitividade. </p>
                        <p>Estamos comprometidos em ajudar as indústrias locais a adotar essas tecnologias e alcançar novos patamares de eficiência e sucesso.</p>
                        {/* <h2>Nossos Clientes</h2> */}
                        {/* <Carousel responsive={responsive} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={image1} alt="3e engenharia" />
                            </div>
                            <div className="item">
                                <img src={image2} alt="Empórop Brownie" />
                            </div>
                            <div className="item">
                                <img src={image3} alt="cemag" />
                            </div>
                            <div className="item">
                                <img src={image4} alt="Ibel" />
                            </div>
                            <div className="item">
                                <img src={image5} alt="Agromix" />
                            </div>
                            <div className="item">
                                <img src={image6} style={{marginTop: 30}} alt="SENAI" />
                            </div>
                            <div className="item">
                                <img src={image8} style={{marginTop: 20}} alt="Cleo bem alimentos" />
                            </div>
                            <div className="item">
                                <img src={image9} style={{marginTop: 20}} alt="Límpida" />
                            </div>
                            <div className="item">
                                <img src={image10} style={{marginTop: 25}} alt="Marix" />
                            </div>
                            <div className="item">
                                <img src={image11} style={{marginTop: 30}}alt="Pomar" />
                            </div>
                            <div className="item">
                                <img src={image12} style={{marginTop: 25}} alt="Pardal" />
                            </div>
                        </Carousel>  */}
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
